import React from 'react'
import Layout from '../../components/Layout'
import Container from '../../components/Container'
import PageTitle from '../../components/PageTitle'
import BodyPlaceholder from '../../components/BodyPlaceholder'
import UnderConstruction from '../../components/UnderConstruction'
import SEO from '../../components/SEO'

const Media = ({ data }) => {
  return (
    <Layout>
      <SEO title="미디어 | 소식 - 죠이플 교회" description="Video and photo albums" />
        <UnderConstruction title={`소식 / 미디어`} />
    </Layout>
    // <Layout>
    //   <Container>
    //     <PageTitle>미디어</PageTitle>
    //     <BodyPlaceholder body={`<div>소식 / 미디어</div>`} />
    //   </Container>
    // </Layout>
  )
}

export default Media
